import { isNil, includes, equals } from 'ramda'
import isTruthy from './is-truthy'

const EMPTY_RESULT = { users: {} }

const isEmpty = equals(EMPTY_RESULT)

export const isInTenantsTab = suiteInfo => {
  // Still loading response in this case
  if (!suiteInfo) return null
  // This implies that a listing is in history,
  // and therefore on tenants
  if (!isTruthy(suiteInfo) || isEmpty(suiteInfo)) return true
  // Otherwise if it is in any of these states,
  // it must be on the tenants tab
  const state = suiteInfo?.state_machine
  return includes(state, ['upcoming', 'rented', 'history'])
}

export const getTab = suiteInfo => {
  const value = isInTenantsTab(suiteInfo)
  if (isNil(value)) return ''
  return value ? 'tenant' : 'listing'
}
